import JSONAPIDeserializer from "jsonapi-serializer/lib/deserializer";

export const deserializedData = async (data) => new JSONAPIDeserializer({
    keyForAttribute: 'underscore_case',
}).deserialize(JSON.parse(JSON.stringify(data)), (err, deserializeData) => deserializeData);